import { all } from 'redux-saga/effects';
import AuthSagas from './Auth/sagas';
import AdminsSagas from './Admins/sagas';
import CategoriesSagas from './Categories/sagas';
import ServicesSagas from './Services/sagas';
import SpecialtiesSagas from './Specialties/sagas';
import ProvidersSagas from './Providers/sagas';
import BranchesSagas from './Branches/sagas';
import EmployeesSagas from './Employees/sagas';
import CustomersSagas from './Customers/sagas';
import BookingsSaga from './Bookings/sagas';
import LookUpsSagas from './LookUps/sagas';
import SettingsSagas from './Settings/sagas';
import NotificationsSagas from './Notifications/sagas';
import PaymentTransactionsSagas from './PaymentTransactions/sagas';
import OutstandingBalanceSagas from './OutstandingBalance/sagas';
import ExpensesSagas from './Expenses/sagas';

export default function* rootSaga() {
  yield all([
    AuthSagas(),
    AdminsSagas(),
    CategoriesSagas(),
    SpecialtiesSagas(),
    ServicesSagas(),
    ProvidersSagas(),
    BranchesSagas(),
    EmployeesSagas(),
    BookingsSaga(),
    LookUpsSagas(),
    CustomersSagas(),
    SettingsSagas(),
    NotificationsSagas(),
    PaymentTransactionsSagas(),
    OutstandingBalanceSagas(),
    ExpensesSagas(),
  ]);
}
